// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { BilancioEnteRigaDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class BilancioEnteRigaApiClient extends BaseCRUDApiClient<BilancioEnteRigaDto> {
  baseUrl = this.config.apiEndpoint + '/bilancio-ente-riga';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
